import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a193a] text-white/80 pt-20 pb-10 border-t border-white/10" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16" data-id="element-63">
          {/* Brand Col */}
          <div className="lg:col-span-4" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/9pNo3tTwvFYBri2vFZFThu/Arissa_Cost_Solutions_Logo.png" alt="Arissa Cost Solutions" className="h-12 w-auto mb-6 object-contain" data-id="element-65" />
            <p className="text-sm leading-relaxed mb-6 max-w-sm" data-id="element-66">
              Helping employers navigate care for their injured workers. We
              provide highly integrated and comprehensive managed care services
              for Workers' Compensation and liability claims.
            </p>
            <div className="flex space-x-4" data-id="element-67">
              <a href="#" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-68">
                <Linkedin className="w-5 h-5" data-id="element-69" />
              </a>
              <a href="#" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-70">
                <Twitter className="w-5 h-5" data-id="element-71" />
              </a>
            </div>
          </div>

          {/* Services Col */}
          <div className="lg:col-span-3 lg:col-start-6" data-id="element-72">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-73">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-74">
              <li data-id="element-75">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-76">
                  A+ Ancillary Services
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-78">
                  Workers' Comp Managed Care
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-80">
                  Medical Bill Review
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-82">
                  Case Management
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-84">
                  Utilization Review
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-86">
                  Medicare Set-Aside
                </Link>
              </li>
              <li className="pt-3 mt-3 border-t border-white/10" data-id="element-87">
                <Link to="/about" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-88">
                  About Us
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/contact" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-90">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="lg:col-span-4" data-id="element-91">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-92">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-93">
              <li className="flex items-start" data-id="element-94">
                <Phone className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-95" />
                <div data-id="element-96">
                  <div data-id="element-97">
                    <a href="tel:8552601053" className="hover:text-white transition-colors" data-id="element-98">
                      855.260.1053
                    </a>{' '}
                    (Toll Free)
                  </div>
                  <div className="mt-1" data-id="element-99">
                    <a href="tel:7142591053" className="hover:text-white transition-colors" data-id="element-100">
                      714.259.1053
                    </a>{' '}
                    (Local)
                  </div>
                </div>
              </li>
              <li className="flex items-center" data-id="element-101">
                <Mail className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-102" />
                <a href="mailto:info@arissacs.com" className="hover:text-white transition-colors" data-id="element-103">
                  info@arissacs.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-104">
                <MapPin className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-105" />
                <span data-id="element-106">
                  Corporate Headquarters
                  <br data-id="element-107" />
                  123 Managed Care Way, Suite 100
                  <br data-id="element-108" />
                  Irvine, CA 92614
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/50" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} Arissa Cost Solutions. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-111">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-112">
              Privacy Policy
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-113">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-114">
              Compliance
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}